export const textFieldStyles = {
    "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
            borderColor: "#b7ab90",
        },
    },
    "& .MuiInputLabel-root": {
        "&.Mui-focused": {
            color: "#b7ab90",
        },
    },
};